/**
 * Brand logomark ("Ascensão") — from evplanner-design-system/project/EvPlanner
 * Logo - Brand Sheet.html. Uses currentColor so it inherits from its wrapper.
 */
export function LogoMark({ className, ...props }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden {...props}>
      <path
        d="M11 52C23 49 27 40 31 30C35 20 41 14 50 12"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <circle cx="51" cy="13" r="6.5" fill="currentColor" />
    </svg>
  );
}
